"use client";

import { useFormContext } from "react-hook-form";
import { Button } from "./ui/button";

export function SubmitButton({
  children,
  submitting,
  disabled,
  className,
}: {
  children?: React.ReactNode;
  submitting: boolean;
  disabled?: boolean;
  className?: string;
}) {
  const form = useFormContext();
  const isValid = form.formState.isValid;
  return (
    <>
      <Button
        type="submit"
        disabled={submitting || disabled || !isValid}
        className={className}
        variant="signup"
      >
        {children ?? "Continue"}
      </Button>
    </>
  );
}
